<app-content  [modelInfo]="modelInfo" [domain]="['27km', '09km', '03km']"></app-content>